import styled from "styled-components";

import { RASTER_LANDINGS } from "@ryde/assets-landings";
import { DATA_E2E_KEY, IStyledAttributes } from "@ryde/shared";
import { MOBILE_BREAKPOINT } from "@ryde/theme";
import { landingColors } from "@ryde/utils-landings";

export const TnufaWrapper = styled.div.attrs<IStyledAttributes>({
  [DATA_E2E_KEY]: "tnufa-wrapper",
})`
  width: 100%;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  background: url(${RASTER_LANDINGS.TnufaBgJPG}) no-repeat;
  background-size: 100% auto;

  @media (max-width: ${MOBILE_BREAKPOINT}) {
    background: white;
  }

  .landing-outside-container {
    width: 100%;
    margin: 0px;
    height: 100vh;
    padding: 100px 0px;
    overflow: auto;
    scrollbar-width: none;
    -ms-overflow-style: none;

    @media (max-width: ${MOBILE_BREAKPOINT}) {
      width: 100%;
      padding: 0px;
    }
  }

  .landing-container {
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    background: white;
    border-radius: 10px;
    border: 1px solid #b3b3b3;
    box-shadow: 6px 10px 4px 0 rgba(0, 0, 0, 0.25);
    padding: 20px 70px;
    max-width: 500px;
    width: 100%;
    position: relative;
    align-items: center;

    form {
      display: flex;
      flex-direction: column;
    }

    .messages-display-container {
      width: 100%;
    }

    @media (max-width: ${MOBILE_BREAKPOINT}) {
      padding: 40px;
      box-shadow: none;
      width: 100%;
      border: none;
      gap: 8px;
      min-height: 100%;
    }
  }

  .landing-logo {
    display: flex;
    justify-content: center;
    margin-bottom: 25px;
    cursor: pointer;
    border: none;
    background: transparent;
    padding: 0;

    &:focus-visible {
      outline: 2px solid ${landingColors.royalPurple};
      outline-offset: 2px;
    }

    .landing-logo__img {
      @media (max-width: ${MOBILE_BREAKPOINT}) {
        margin-top: 0px;
        width: 310px;
        object-fit: contain;
      }
    }
  }

  .landing-title {
    text-align: center;
    font-size: 24px;
    font-weight: 600;
    color: ${landingColors.royalPurple};
    line-height: 1.4;
  }
  .font-size-30 {
    font-size: 30px;
  }
  .mintGreen {
    color: ${landingColors.mintGreen};
  }
  .text-grey {
    color: ${landingColors.label};
  }
  .landing-title_choose-station {
    margin-bottom: 5px;
  }
  .landing-sub-title {
    text-align: center;
    color: ${landingColors.royalPurple};
  }
  .font-size-18 {
    font-size: 18px;
  }
  .v-green-icon {
    margin: auto;
    margin-bottom: 10px;
  }

  .downloads-app-container {
    display: flex;
    align-items: stretch;
    max-height: 40px;
    justify-content: space-evenly;
    gap: 5px;

    img {
      width: 120px;
      object-fit: contain;
    }
  }

  .divider-bar {
    width: 85px;
    height: 6px;
    margin-block: 15px;
    background: ${landingColors.mintGreen};
    margin-bottom: 20px;
  }

  .landing-form-field {
    margin-bottom: 20px;
    width: 370px;

    @media (max-width: ${MOBILE_BREAKPOINT}) {
      width: 100%;
    }

    label,
    .custom-label {
      display: block;
      margin-bottom: 8px;
      font-weight: 500;
      color: ${landingColors.darkGray};
      font-size: 14px;
    }
  }
  .landing-form-field__email {
    svg {
      display: none;
    }
  }

  .MuiFormControl-root {
    width: 100%;

    .Mui-error {
      text-align: start;
    }
  }

  .landing-accept-terms {
    display: flex;
    column-gap: 10px;
  }

  .landing-top-illustration {
    display: flex;
    justify-content: center;
    margin-bottom: 5px;
  }

  .landing-help-disclaimer {
    color: ${landingColors.red};
  }

  .continue-button {
    align-self: center;
  }

  .purple-link {
    margin-top: 10px;
    color: ${landingColors.textPurple};
    align-self: center;
    border: none;
    background: transparent;
    padding: 0;
    font: inherit;
    cursor: pointer;

    &:focus-visible {
      outline: 2px solid ${landingColors.textPurple};
      outline-offset: 2px;
    }
  }

  .landing-container-footer {
    text-align: center;
    align-self: stretch;
    margin: 30px -70px 0;
    padding-top: 10px;
    border-top: 1px solid #b3b3b3;

    @media (max-width: ${MOBILE_BREAKPOINT}) {
      margin: auto;
    }
  }

  .divider-bar-label {
    background: ${landingColors.label};
    width: 65px;
    height: 1px;
    margin-block: 10px 15px;
  }
  .downloads-app-container {
    text-align: center;
  }
`;
